<ion-card class="card-common ion-no-margin ion-padding text-center">
  <ion-card-content>

    <!-- Card Title -->
    <ion-card-title class="text-white">
      {{title() | translate}}
    </ion-card-title>

    <br />
    <ion-card-subtitle class="text-white">
      {{subTitle() | translate}}
    </ion-card-subtitle>
  </ion-card-content>
</ion-card>